module.exports = __webpack_public_path__ + "img/ErsterWeihnachtsbaum.98f80727.svg";